<template>
  <div>
    <RadioGroup v-model="createdUser.mode" @on-change="createdUserChanged">
      <Radio label="1">
        <span>Нэвтрэх нэр (Бүртгэл №)</span>
      </Radio>
      <Radio label="2">
        <span>Регистр №</span>
      </Radio>
      <Radio label="3">
        <span>Нэр</span>
      </Radio>
    </RadioGroup>
    <!-- @on-search="createdUserFind" -->
    <div
      class="el-input el-input-group el-input-group--append el-input-group--prepend"
    >
      <div class="el-input-group__prepend"  v-if="createdUser.value != ''">
        <a @click="
          createdUser.value = '';
          createdUser.curId = 0;
        "
       >
          <feather type="x" class="text-danger"></feather>
        </a>
      </div>
      <input v-model="createdUser.value" v-on:keyup="checkEnter"
        type="text"
        autocomplete="off"
        class="el-input__inner"
      /><!----><!---->
      <div class="el-input-group__append">
        <a
          ><feather @click="createdUserFind" type="search"></feather></a>
      </div>
      <!---->
    </div>
    <!-- <Input v-model="createdUser.value" @input="checkEnter">
      <Button
        @click="
          createdUser.value = '';
          createdUser.curId = 0;
        "
        v-if="createdUser.value != ''"
        class=""
        slot="prepend"
      >
        <feather type="x" class="text-danger"></feather>
      </Button>
      <a slot="append">
        <feather @click="createdUserFind" type="search"></feather>
      </a>
    </Input> -->
    <template v-if="createdUser.curId != 0">
      <template v-if="createdUser.list.length > 0">
        <div
          @click="handleUserInfoModal(createdUser.curId)"
          class="alert alert-success mg-b-0 mg-t-10"
          role="alert"
          v-if="
            createdUser.list.filter((x) => x.id == createdUser.curId).length > 0
          "
        >
          <span style="display:none">{{
            (userId = createdUser.list.filter(
              (x) => x.id == createdUser.curId
            )[0].userId)
          }}</span>
          <h6 class="alert-heading">Сонгогдсон хэрэглэгч!</h6>
          <p>
            {{
              createdUser.list.filter((x) => x.id == createdUser.curId)[0]
                .fullName
            }},
            {{
              createdUser.list.filter((x) => x.id == createdUser.curId)[0]
                .loginName
            }}
          </p>
        </div>
      </template>
    </template>
    <template v-else>
      <span style="display:none">{{
        (userId = "00000000-0000-0000-0000-000000000000")
      }}</span>
    </template>

    <b-modal
      width="1000"
      hide-footer
      size="lg"
      scrollable
      v-model="createdUser.modal"
      title="Хэрэглэгч сонгох"
    >
      <div>
        <table class="wd-100p table-bordered table-striped">
          <thead>
            <tr>
              <th>№</th>
              <th>Төрөл</th>
              <th>Нэр</th>
              <th>Нэвтрэх нэр (Бүртгэл №)</th>
              <th>Регистр №</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              @click="handleUserInfoModal(u.id)"
              v-for="(u, i) in createdUser.list"
              :key="i"
              class="is-pointer"
            >
              <td>{{ i + 1 }}</td>
              <td>{{ u.locType4Name }}</td>
              <td>{{ u.fullName }}</td>
              <td>{{ u.loginName }}</td>
              <td>{{ u.register }}</td>
              <td class="text-right pd-r-5 pd-y-5">
                <button
                  @click.stop="
                    createdUser.curId = u.id;
                    createdUser.userId = u.userId;
                    createdUser.modal = false;
                    $emit('on-user-finded', {
                      id: createdUser.curId,
                      userId: createdUser.userId,
                    });
                  "
                  type="button"
                  class="btn btn-outline-primary btn-xs"
                >
                  <span>Сонгох</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import { Input, RadioGroup, Radio, Notification } from "element-ui";
import { request } from "@/api/all";
import { mapActions } from "vuex";
export default {
  components: {
    Input,
    RadioGroup,
    Radio,
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => null,
    },
  },
  mounted() {
    if (this.defaultValue != null) {
      this.createdUser.mode = this.defaultValue.mode;
      this.createdUser.value = this.defaultValue.value;
      this.createdUserFind();
    }
  },
  data() {
    return {
      createdUser: {
        mode: "1",
        value: "",
        list: [],
        modal: false,
        curId: 0,
        userId: 0,
      },
    };
  },
  methods: {
    ...mapActions(["handleLoading", "handleAside", "handleUserInfoModal"]),
    createdUserChanged(e) {
      this.createdUser.mode = e;
    },
    checkEnter(e) {
      //console.log(e);
      if (e.keyCode === 13) {
        this.createdUserFind();
      }
    },
    createdUserFind() {
      if (this.createdUser.mode == "1") {
        request({
          api: { url: "Hr/GetUsersByLoginName", method: "GET" },
          params: {
            loginName: this.createdUser.value,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.createdUserFindAfter(res);
          }
        });
      } else if (this.createdUser.mode == "2") {
        request({
          api: { url: "Hr/GetUsersByRegister", method: "GET" },
          params: {
            register: this.createdUser.value,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.createdUserFindAfter(res);
          }
        });
      } else if (this.createdUser.mode == "3") {
        request({
          api: { url: "Hr/GetUsersByFirstName", method: "GET" },
          params: {
            firstName: this.createdUser.value,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.createdUserFindAfter(res);
          }
        });
      }
    },
    createdUserFindAfter(res) {
      //console.log(res);
      this.createdUser.list = res.data.users;
      if (this.createdUser.list.length > 0) {
        if (this.createdUser.list.length == 1) {
          this.createdUser.curId = res.data.users[0].id;
          this.createdUser.userId = res.data.users[0].userId;
          //console.log(res.data.users[0])
          this.$emit("on-user-finded", {
            id: this.createdUser.curId,
            userId: this.createdUser.userId,
          });
        } else {
          this.createdUser.modal = true;
        }
      } else {
        Notification.warning({
          title: "Мэдэгдэл",
          message: `Тохирох илэрц олдсонгүй. Хайх утгаа нягтлаад оролдоно уу`,
          duration: 3000,
          position: "bottom-left",
        });
      }
    },
    // createdUserRemove() {
    //   this.taskEdit.id = id;
    //   this.taskEdit.objectTypeId = this.ot;
    //   this.taskEdit.projectId = this.project.id;
    //   this.taskEdit.render = true;
    //   this.$nextTick(function() {
    //     this.taskEdit.show = true;
    //   });
    // },
  },
};
</script>

<style></style>
